































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import PricelistTemplateListBase from "./PricelistTemplateListBase";

	@Component
	export default class pricelistTemplateList extends PricelistTemplateListBase {
		created() {
            super.initializeRights('ACC_PricelistTemplate_Update', 'ACC_PricelistTemplate_Update', 'ACC_PricelistTemplate_Update', 'ACC_PricelistTemplate_Update');
            super.setDetailName('PricelistTemplateDetail');
			super.created();
		
		}

		selectRows(items: any) {
			super.selectRows(items);
		}

        isSuperUserAllow(){
			return this.isSuperUser;
        }

	
		showAllertToDeleteClick(itemsSelected: any) {
			this.showAlertBeforeDeleteBase(itemsSelected);
		}


		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
		deleteClick(elementId: any) { this.deleteClick(elementId) }
	};
